// From https://github.com/smhg/date-duration/blob/master/src/duration.js
const ISO_REGEXP =
  /P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?/;

function toInt(value = 0) {
  return parseInt(value, 10);
}

function parse(isoString) {
  const matches = String(isoString).match(ISO_REGEXP) || [];
  const [, ...data] = matches;

  const [years = 0, months = 0, weeks = 0, days = 0, hours = 0, minutes = 0, seconds = 0] =
    data.map(toInt);

  return {
    years,
    months,
    weeks,
    days,
    hours,
    minutes,
    seconds,
  };
}

function toSecond(isoStringParsed) {
  const { years, months, weeks, days, hours, minutes, seconds } = isoStringParsed;

  if (years > 0 || months > 0) {
    throw new Error("don't use years or month which is not enough precise for second conversion");
  }

  return seconds + minutes * 60 + hours * 60 * 60 + days * 60 * 60 * 24 + weeks * 60 * 60 * 24 * 7;
}

export default {
  parse,
  toSecond,
};
